export function truncateAddress(str: string | undefined, keepLength = 10) {
  if (!str) {
    return '';
  }
  if (str.length <= keepLength * 2 + 3) {
    return str;
  }
  return (
    str.substring(0, keepLength) +
    '...' +
    str.substring(str.length - keepLength)
  );
}
